<template>
  <div class="payment-list-wrap">
    <template-search-list :listApi="listApi"
                          :buttonOption="buttonOption"
                          :defaultSortBy="defaultSortBy"
                          :initialSearchFilter="initialSearchFilter"
                          :reload="reload"
                          :selected="selected"
                          @select="setSelected"
                          @searchFilter="getSearchFilter"
                          @showDetail="showDetail">
      <ui-button :color="'green'"
                 @click="toggleInsert">
        <i class="xi-plus"></i> JAM 충전
      </ui-button>
      <ui-button :color="'purple'"
                 @click="toggleExcel(true)">
        <i class="xi-view-list"></i> 엑셀 다운로드
      </ui-button>
    </template-search-list>

    <template-insert :show="show.insert"
                     :metaApi="insertMetaApi"
                     :insertApi="insertApi"
                     :makePayment=true
                     @reload="reloadList"
                     @saved="showDetail"
                     @close="toggleInsert">
      <h4 class="title"><i class="bi-jam"></i> JAM 충전</h4>
    </template-insert>

    <template-detail :infoApi="infoApi"
                     :editApi="editApi"
                     :cancelApi="cancelApi"
                     :cancelMetaApi="cancelMetaApi"
                     :apiParam="apiParam"
                     :service="'jam'"
                     @reload="reloadList"
                     @paidCancel="paidCancel"
                     @close="setSelected">
    </template-detail>

    <excel-column-select :excelDownload="excelDownload"
                         :metaApi="excelListMetaApi"
                         :listApi="listApi"
                         :searchFilter="searchFilter"
                         @export="excelExport"
                         @close="toggleExcel(false)"/>
  </div>
</template>

<script>
import {
  getJamPaymentHistoryList,
  insertJamPayment,
  getJamPaymentHistoryInsertMeta,
  getJamPaymentHistoryExcelMeta,
  editJamPaymentHistoryInfo,
  getJamPaymentHistoryInfo,
  cancelJamPaymentHistory,
  getJamPaymentCancelMeta
} from '@/api/payment'

import TemplateSearchList from '@/components/_template/SearchList'
import TemplateDetail from '@/components/_template/Detail'
import TemplateInsert from '@/components/_template/Insert'
import UiButton from '@/components/_ui/UiButton'

import Excel from '@/utils/excel-export'
import ExcelColumnSelect from '@/components/_template/ExcelColumnSelect'
import { EventBus } from '@/utils/event-bus'
import { format } from 'date-fns'
import { STORAGE_ITEM } from '@/utils/constants'

export default {
  name: 'JamPaymentList',
  components: {
    ExcelColumnSelect,
    TemplateSearchList,
    TemplateDetail,
    TemplateInsert,
    UiButton
  },
  created () {
    // console.log('eventbus: ', EventBus.$on('searchData', this.apiParam))
    const localStorageData = localStorage.getItem(STORAGE_ITEM.searchData)
    if (localStorageData !== '{}' || localStorageData !== 'null') {
      const searchData = JSON.parse(localStorageData)
      if (searchData && searchData.userId && searchData.userNum) {
        this.initialSearchFilter = {}
        this.initialSearchFilter.userId = searchData.userId
        this.initialSearchFilter.userNum = searchData.userNum
        this.initialSearchFilter.userIdExact = true
      } else if (searchData && searchData.id) {
        this.initialSearchFilter = {}
        this.initialSearchFilter.id = searchData.id
      }
    }
    localStorage.setItem(STORAGE_ITEM.searchData, null)
  },
  methods: {
    showDetail (data) {
      this.apiParam = { id: data._id }
    },
    reloadList () {
      this.reload++
    },
    toggleInsert (value = null) {
      this.apiParam = null
      if (value !== null) {
        this.show.insert = !this.show.insert
      } else {
        this.show.insert = value
      }
    },
    paidCancel (value) {
      this.cancelMode = !this.cancelMode
      this.toggleInsert(value)
    },
    toggleExcel (value = false) {
      this.excelDownload = value
    },
    excelExport (col, data, selectCol) {
      const fileName = 'eagle_beus_payment_history'
      const excel = new Excel()
      EventBus.$emit('onLoading', true)
      excel.setExcelData('planBeus', col, data || [], selectCol, {})
        .then(result => {
          excel.download(fileName)
          this.excelDownload = false
          EventBus.$emit('onLoading', false)
        }).catch(e => {
          EventBus.$emit('onLoading', false)
        })
    },
    getSearchFilter (value) {
      this.searchFilter = value
    },
    getStartDate () {
      let currenDate = new Date()
      currenDate.setDate(currenDate.getDate() - 6)
      return format(currenDate, 'yyyy-MM-dd')
    },
    setSelected (row) {
      this.selected = row
    }
  },
  data () {
    return {
      reload: 0,
      selected: null,
            
      infoApi: getJamPaymentHistoryInfo,
      editApi: editJamPaymentHistoryInfo,
      cancelApi: cancelJamPaymentHistory,
      cancelMetaApi: getJamPaymentCancelMeta,
      apiParam: null,

      listApi: getJamPaymentHistoryList,
      insertApi: insertJamPayment,
      insertMetaApi: getJamPaymentHistoryInsertMeta,
      excelListMetaApi: getJamPaymentHistoryExcelMeta,
      buttonOption: [
        {
          action: 'showDetail',
          columnText: '자세히',
          buttonText: '<i class="xi-arrow-right"></i>'
        }
      ],
      defaultSortBy: '-paymentDate',
      cancelMode: false,

      show: {
        insert: false
      },
      excelDownload: false,
      searchFilter: {},
      initialSearchFilter: {
        paymentDate: {
          start: this.getStartDate(),
          end: format(new Date(), 'yyyy-MM-dd')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.payment-list-wrap {
}
</style>
